
export const getUri = (): string => {
  const isProd = process.env.NODE_ENV === 'production' || true;
  return isProd ? 'https://lithuanianhotels.lt' : 'http://localhost:3030';
};
